import React from 'react';
import IdleScreen from 'screens/Game/IdleScreen';

const PreviewIdleScreen = () => {
  return <IdleScreen />;
};

export default PreviewIdleScreen;
